import { Modal } from "antd";
import useMobileDetect from "@/hooks/useMobileDetect";
import Image from "next/image";
import RegisterCoupon from "@/app/assets/activity/RegisterCoupon.webp";
import ShopCoupon from "@/app/assets/activity/ShopCoupon.webp";
import Close from "@/app/assets/activity/Close.svg";
import "./style/Coupon.css";

export enum CouponType {
  "REGISTER" = "REGISTER",
  "SHOP" = "SHOP",
}

export type CouponProps = {
  open: boolean;
  type?: CouponType;
  onClose?: () => void;
};

export const Coupon: React.FC<CouponProps> = ({
  open,
  onClose,
  type = CouponType.SHOP,
  ...props
}) => {
  const isMobile = useMobileDetect();

  return (
    <Modal
      open={open}
      width="297"
      centered
      closable={false}
      footer={null}
      maskClosable
      onCancel={onClose}
      style={{ backgroundColor: "transparent" }}
      className="CouponModal"
    >
      {type === CouponType.REGISTER ? (
        <>
          <Image
            src={RegisterCoupon}
            width={isMobile ? 297 : 330}
            height={isMobile ? 346 : 385}
            alt="register"
            onClick={() => {
              onClose && onClose()
              globalThis.document.getElementById("signInBtn")?.click();
            }}
          />
          <div className="flex justify-center mt-32" onClick={onClose}>
            <Close width={40} className="cursor-pointer" />
          </div>
        </>
      ) : (
        <>
          <Image
            src={ShopCoupon}
            width={isMobile ? 340 : 380}
            height={isMobile ? 364 : 404}
            alt="ShopCoupon"
          />
          <div
            className={`${isMobile ? "mt-36" : "mt-26"} flex justify-center`}
            onClick={onClose}
          >
            <Close width={40} className="cursor-pointer" />
          </div>
        </>
      )}
    </Modal>
  );
};
